.width-slider{width:250px}.number-label{width:3em}.toolbar-container{display:flex;gap:var(--ursa--padding)}.lock-mask{padding:4px 10px;background-color:#e9ebed;border:1px solid #ccc;border-radius:4px}
/*# sourceMappingURL=paintbrush-secondary-toolbar.component.css.map */
